import React, { Component } from 'react'
import { Spin, Button, Table, Layout, Input, Switch, Row, Col, Modal, Form, message, Cascader, InputNumber, Calendar, Tag, Icon, } from 'antd'
import {healthList, editHealth, healthChangeStatus, healthDetail} from '_src/api/api'
import axios from 'axios'
import moment from 'moment'
import './style.less'

const { Search } = Input

@Form.create({name: ''})
class GoodType extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,

      createModelVisible: false,
      stopId:'',
      busDestination:'',
      
      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0, 
        current: 1, 
      },

      list: [],

      banDate: [],
      columns: [
        {
          title: <span>线路号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>专线名称</span>,
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: <span>专线终点</span>,
          align: 'center',
          dataIndex: 'lineDestination',
        },
        {
          title: <span>平台价格（元）</span>,
          align: 'center',
          dataIndex: 'platformPrice',
          render: item => (item / 100).toFixed(2),
        },
        {
          title: <span>第三方价格（元）</span>,
          align: 'center',
          dataIndex: 'foreignPrice',
          render: item => (item / 100).toFixed(2),
        },
        {
          title: <span>合计价格</span>,
          align: 'center',
          render: item => ((item.platformPrice + item.foreignPrice) / 100).toFixed(2),
        },
        {
          title: <span>创建日期</span>,
          align: 'center',
          dataIndex: 'createAt',
        },
        {
          title: <span>线路状态</span>,
          align: 'center',
          dataIndex: 'status',
          render: item => <div>{item === 1 ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : <Icon type="close-circle" theme="filled" style={{color: '#ccc', fontSize: 18}} /> }</div>
        },
        {
          title: <span>停售日期</span>,
          align: 'center',
          dataIndex: 'banDate',
          render: item => item && item.length > 2 ? '有停售' : '无'
        },
        {
          title: <span>操作</span>,
          align: 'center',
          width: 290,
          render: item => <div>
            <Button icon="edit" onClick={() => { this.edit(item.id) }} style={{marginRight: '10px'}}>编辑</Button>
            <Button icon="calendar" type="danger" onClick={() => { this.onBanDate(item.id) }} style={{marginRight: '10px'}}>停售日</Button>
            <Switch checked={item.status === 1} checkedChildren="上架" unCheckedChildren="下架" onClick={()=> this.changeStatus(item.id)} /> 
          </div>,
        },
      ]
      
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.loadList(params)
  }

  loadList (params) {
    this.setState({isLoading: true})
    healthList(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 通用切换事件
  commonChange = (e, key) => {
    const {params} = this.state
    params.pageNum = 0
    if (e) {
      params[key] = e
    } else {
      delete params[key]
    }
    this.setState({params})
    this.loadList(params)
  }

  // 切换显示状态
  changeStatus = (id) => {
    const _this = this
    const {list, params} = this.state
    const selectData = list.filter(item => item.id === id)[0]
    const title = selectData.status === 0 ? '上架提醒' : '下架提醒'
    const content = selectData.status === 0 ? '确定要上架这个专线？' : '确定要下架这个专线？'
    Modal.confirm({
      title,
      content,
      onOk () {
        const hide = message.loading('数据提交中...')
        healthChangeStatus({id})
          .then(res => {
            hide()
            message.success('操作成功！', 1.2, ()=>{
              _this.loadList(params)
            })
          })
      },
      onCancel () {
        //
      },
    })
  }

  // 编辑
  edit = (id) => {
    const hide = message.loading('加载专线详情', 0)
    this.loadStation()
      .then(station => {
        healthDetail({id})
          .then(res => {
            hide()
            const data = res.data
            data.banDate = JSON.parse(data.banDate)
            const selectStation = station.all.filter(item => item['站点'] === data.busDestination)[0]
            data.busDestination = [selectStation['所属省份'], selectStation['所属地区'], selectStation['stopId']]
            this.setState({
              stationList: station.stationList,
              all: station.all,
              info: data,
              banDate: data.banDate,
              visible: true,
              isLoading: false,
              stopId:data.stopId,
              busDestination:selectStation['站点']
            })
          })
          .catch(err => {
            console.log(err)
          })
      })
  }

  // 禁用日期选择
  onBanDate = (id) => {
    healthDetail({id})
      .then(res => {
        const banDate = JSON.parse(res.data.banDate)
        this.setState({
          banDateEdit: true,
          banDateInfo: res.data,
          banDate,
        })
      })
  }

  // 列表编辑禁用日期的回调
  editBandate = () => {
    let {banDate, banDateInfo, params} = this.state
    const day = moment().format('YYYY-MM-DD')
    banDateInfo.banDate = banDate.filter(item => item >= day)
    const hide = message.loading('数据提交中', 0)
    editHealth(banDateInfo, banDateInfo.id)
      .then(res => {
        hide()
        this.setState({
          banDateEdit: false,
          banDate: [],
        })
        this.loadList(params)
      })
  }

  // 加载站点信息
  loadStation = () => {
    return new Promise((resolve, reject) => {
      const {stationList, all} = this.state
      if (stationList && all) {
        resolve({stationList, all})
      } else {
        axios.get('https://ticket-java.gdhttech.com/station/data?start_station=3')
          .then(res => {
            const stationList = this.initList(res.data.tree)
            const all = res.data.all
            resolve({stationList, all})
          })
          .catch(err => {
            reject(err)
            message.error('目的地站点加载失败', 2)
          })
      }
    })
  }

  // 创建
  create = () => {
    this.loadStation().then(res => {
      this.setState({
        stationList: res.stationList,
        all: res.all,
        visible: true,
      })
    })
  }

  // 数据格式化
  initList (list) {
    const keys = Object.keys(list)
    const data = []
    keys.forEach(item => {
      if (list[item].pinyin) {
        data.push({
          value: list[item]['stopId'],
          label: list[item]['站点'],
        })
      } else {
        data.push({
          value: item,
          label: item,
          children: this.initList(list[item]),
        })
      }
    })
    return data
  }
  
  // 提交创建详情
  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const {banDate, info,stopId,busDestination} = this.state
        const id = info ? info.id : ''
        const day = moment().format('YYYY-MM-DD')
        values.banDate = banDate.filter(item => item >= day)
        values.startStation = '3'
        values.stopId = stopId
        values.busDestination = busDestination
        values.status = values.status ? 1 : 0
        values.platformPrice = values.platformPrice * 100
        values.foreignPrice = values.foreignPrice * 100
        // 提交
        const hide = message.loading('数据提交中', 0)
        editHealth(values, id)
          .then(res => {
            hide()
            const _this = this
            const {params} = this.state
            this.setState({
              visible: false,
              banDate: [],
              info: '',
            })
            message.success('提交成功！', 1.2, () => {
              _this.loadList(params)
            })
          })
          .catch(err => {
            hide()
          })
      }
    })
  }

  // 删除禁用日期标签选择
  closeTag = (item) => {
    const {banDate} = this.state
    const newDate = banDate.filter(child => child !== item)
    this.setState({banDate: newDate}) 
  }
  // 编辑禁用日期回调
  addTag = (item) => {
    const date = moment(item).format('YYYY-MM-DD')
    let {banDate} = this.state
    if (!banDate.includes(date)) {
      banDate.push(date)
    } else {
      banDate = banDate.filter(child => child !== date)
    } 
    this.setState({
      banDate,
      banDateVisible: false,
    })
  }

  render () {
    const {
      isLoading, 
      visible,
      list, 
      info,
      columns, 
      pageData, 
      stationList,
      banDate,
      banDateEdit,
    } = this.state

    const { getFieldDecorator } = this.props.form

    return (
      <Layout className="goodType-page" style={{ padding: 20, backgroundColor: 'white' }}>
        {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <Row style={{ paddingBottom: 20 }}>
          <Col lg={{ span: 8 }} style={{ width: 180, marginBottom: 20 }} className="flex-h-a">
            <Button className='creat-station' type="primary" icon="plus" style={{ width: 150 }} onClick={this.create}>新增健康专线</Button>
          </Col>
          <Col lg={{ span: 16 }} className="flex-h-a">
            <span>路线搜索：</span>
            <Search style={{ width: 300 }} placeholder="线路名称搜索" onSearch={(e)=>this.commonChange(e, 'name')} enterButton />
          </Col>
        </Row>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
        <Modal
          title={info ? '编辑健康专线' : '新增健康专线'}
          visible={visible}
          onCancel={()=>{
            this.setState({
              banDate: [],
              info: '',
              visible: false,
            })
          }}
          width={640}
          footer={false}
          destroyOnClose
        >
          <Form onSubmit={this.onSubmit} className="healthList-form">
            <Form.Item label="专线名称" className='flex'>
              {getFieldDecorator('name', {
                rules: [{
                  required: true,
                  message: '请输入健康专线名称',
                }],
                initialValue: info && info.name ? info.name : '',
              })(
                <Input placeholder="请输入健康专线名称" style={{width: 350}} />
              )}
            </Form.Item>
            <Form.Item label="专线目的地" className='flex'>
              {getFieldDecorator('lineDestination', {
                rules: [{
                  required: true,
                  message: '请输入专线目的地',
                }],
                initialValue: info && info.lineDestination ? info.lineDestination : '',
              })(
                <Input placeholder="请输入健康专线目的地" style={{width: 350}} />
              )}
            </Form.Item>
            <Form.Item label="班车出发地" className='flex'>
              <Input value='惠州汽车客运站（不可改）' style={{width: 350}} readOnly />
            </Form.Item>
            <Form.Item label="班车目的地" className='flex'>
              {getFieldDecorator('busDestination', {
                rules: [{
                  required: true,
                  message: '请选择班车目的地',
                }],
                initialValue: info ? info.busDestination : '',
              })(
                <Cascader
                  options={stationList}
                  placeholder="请选择班车目的地"
                  style={{width: 350}}
                  showSearch
                  onChange={(value, selectedOptions) => {
                    this.setState({
                      stopId:selectedOptions[2]['value'],
                      busDestination:selectedOptions[2]['label']
                    })
                  }}
                />,
              )}
            </Form.Item>
            <Form.Item label="第三方收费金额：" className='flex'>
              {getFieldDecorator('foreignPrice', {
                rules: [{
                  required: true,
                  message: '请输入第三方收费金额',
                }],
                initialValue: info && info.foreignPrice ? (info.foreignPrice / 100).toFixed(2) : '',
              })(
                <InputNumber placeholder="第三方收费金额" style={{width: 350}} />
              )}
            </Form.Item>
            <Form.Item label="平台收费金额：" className='flex'>
              {getFieldDecorator('platformPrice', {
                rules: [{
                  required: true,
                  message: '请输入平台收费金额',
                }],
                initialValue: info && info.platformPrice ? (info.platformPrice / 100).toFixed(2) : '',
              })(
                <InputNumber placeholder="平台收费金额" style={{width: 350}} />
              )}
            </Form.Item>
            <Form.Item label="禁售日期：" className='flex'>
              <div className='flex banDate-box'>
                {
                  banDate.map(item => <Tag closable key={item} onClose={()=> this.closeTag(item)}>{item}</Tag>)
                }
                <Tag onClick={()=>this.setState({banDateVisible: true})} style={{ background: '#fff', borderStyle: 'dashed' }}><Icon type="plus" /> 选择日期</Tag>
              </div>
            </Form.Item>
            <Form.Item label="使用状态：" className='flex'>
              {getFieldDecorator('status', {
                // initialValue: !!(info && info.status),
                initialValue: info ? (!!info.status) : true,
                valuePropName: 'checked'
              })(
                <Switch checkedChildren="上架" unCheckedChildren="下架" />
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" size='large' htmlType="submit" style={{width: 400, marginLeft: 100}}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
        <BanDate dates={banDate} visible={this.state.banDateVisible} onSelect={this.addTag} onCancel={()=>this.setState({banDateVisible: false, banDate: []})} />
        <ListBanDate dates={banDate} visible={banDateEdit} onSelect={this.addTag} onOk={this.editBandate} onCancel={()=>this.setState({banDateEdit: false, banDate: []})} />
      </Layout>
    )
  }
}

export default GoodType

// 编辑内选择禁用日期
class BanDate extends Component { 
  now = moment().format('YYYY-MM-DD')
  dateFullCellRender = (item) => {
    const {dates} = this.props
    const date = moment(item).format('YYYY-MM-DD')
    const day = moment(item).format('DD')
    if (dates.includes(date)) {
      return <div className='flex-a' style={{width: 40, height: 24, margin: '0 auto', backgroundColor: '#ff4447', color: '#fff', borderRadius: 4}}>{day}</div>  
    } else {
      return <div className='flex-a' style={{width: 40, height: 24, margin: '0 auto'}}>{day}</div>  
    }
  }
  disabledDate = (item) => {
    const date = moment(item).format('YYYY-MM-DD')
    return date < this.now
  }
  render () {
    const {visible, onSelect, onCancel} = this.props
    return (
      <Modal
        title='添加禁用日期'
        visible={visible}
        onCancel={onCancel}
        width={700}
        footer={false}
        destroyOnClose
        maskClosable
      >
        <div className='banDade-modal'>
          <Calendar dateFullCellRender={this.dateFullCellRender} disabledDate={this.disabledDate} fullscreen={false} onSelect={onSelect} />
        </div>
      </Modal>

    )
  }
}

// 列表选择禁用日期
class ListBanDate extends Component { 
  now = moment().format('YYYY-MM-DD')
  dateFullCellRender = (item) => {
    const {dates} = this.props
    const date = moment(item).format('YYYY-MM-DD')
    const day = moment(item).format('DD')
    if (dates.includes(date)) {
      return <div className='flex-a' style={{width: 40, height: 24, margin: '0 auto', backgroundColor: '#ff4447', color: '#fff', borderRadius: 4}}>{day}</div>  
    } else {
      return <div className='flex-a' style={{width: 40, height: 24, margin: '0 auto'}}>{day}</div>  
    }
  }
  disabledDate = (item) => {
    const date = moment(item).format('YYYY-MM-DD')
    return date < this.now
  }
  render () {
    const {visible, onSelect, onCancel, onOk} = this.props
    return (
      <Modal
        title='选择禁用日期'
        okText='确定选择'
        visible={visible}
        onCancel={onCancel}
        onOk={onOk}
        width={700}
        destroyOnClose
        maskClosable
      >
        <div className='banDade-modal'>
          <Calendar dateFullCellRender={this.dateFullCellRender} disabledDate={this.disabledDate} fullscreen={false} onSelect={onSelect} />
        </div>
      </Modal>

    )
  }
}